import { HighlightColorModel } from "./highlight-values-model";
import { OCRUploadEntityFileRequestModel } from "./ocr-upload-entity-file-request-model";

export class OCRCreateColorHighlightedKeywordFileRequestModel extends OCRUploadEntityFileRequestModel {
    keywords: { [k: string]: HighlightColorModel; } | any ;
}